import PropTypes from "prop-types";

import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import MDTypography from "components/MDTypography";

export const SOCIAL_PLATFORMS = [
  "twitter",
  "linkedin",
  "facebook",
  "instagram",
  "youtube",
  "tiktok",
  "threads",
];

/**
 * Batch 2.6 — <SocialPostFields>. The Social-post type block. `platform` is
 * required; the backend injects a System author, so this type carries no
 * author select.
 */
function SocialPostFields({ value, onChange }) {
  return (
    <Stack spacing={3}>
      <MDTypography variant="button" fontWeight="bold" textTransform="uppercase" color="text">
        Social post details
      </MDTypography>

      <TextField
        select
        label="Platform"
        value={value.platform}
        onChange={(e) => onChange({ platform: e.target.value })}
        fullWidth
        required
      >
        <MenuItem value="" disabled>
          Select a platform
        </MenuItem>
        {SOCIAL_PLATFORMS.map((platform) => (
          <MenuItem key={platform} value={platform} sx={{ textTransform: "capitalize" }}>
            {platform}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        label="Author name"
        value={value.author_name}
        onChange={(e) => onChange({ author_name: e.target.value })}
        fullWidth
      />
      <TextField
        label="Author handle"
        value={value.author_handle}
        onChange={(e) => onChange({ author_handle: e.target.value })}
        fullWidth
        placeholder="@handle"
      />
      <TextField
        label="Author avatar URL"
        value={value.author_avatar_url}
        onChange={(e) => onChange({ author_avatar_url: e.target.value })}
        fullWidth
      />
      <TextField
        label="External URL"
        value={value.external_url}
        onChange={(e) => onChange({ external_url: e.target.value })}
        fullWidth
        helperText="Link to the original post"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(value.is_featured)}
            onChange={(e) => onChange({ is_featured: e.target.checked })}
          />
        }
        label="Featured post"
      />
    </Stack>
  );
}

SocialPostFields.defaultProps = {
  websiteId: undefined,
  context: {},
};

SocialPostFields.propTypes = {
  value: PropTypes.shape({
    platform: PropTypes.string,
    author_name: PropTypes.string,
    author_handle: PropTypes.string,
    author_avatar_url: PropTypes.string,
    external_url: PropTypes.string,
    is_featured: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  websiteId: PropTypes.string,
  context: PropTypes.object,
};

export default SocialPostFields;
